import React, { useState } from 'react';
import CustomTab from "../../../../components/CustomTab";
import CustomTabContainer from "../../../../components/CustomTabContainer";
import ResidentWhiteListAutomatic from "./ResidentWhiteListAutomatic";
import ResidentWhiteListManual from "./ResidentWhiteListManual";
import { TABS_WHITE_LIST_MODEL } from "../../../Dashboard/Events/Requested/Model/Models";
import { useTranslation } from "react-i18next";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Tabs used to add residents to the white list of a building, the automatic one
 * uploads the template file and the manual one captures the emails by hand.
 *
 * @param {boolean} props.emptyFields - Empty field validation flag of the manual tab.
 * @param {Function} props.setEmptyFields - Sets the empty field validation flag.
 * @param {Function} props.setDisplayModal - Hides the modal holding the tabs while another one is open.
 * @param {Object} props.photoPickerFile - File selected on the automatic tab.
 * @param {Function} props.setPhotoPickerFile - Sets the file of the automatic tab.
 * @param {Object} props.whiteListDetail - Form model holding the manual white list.
 * @param {Function} props.setWhiteListDetail - Updates the form model.
 */
const ResidentWhiteListTabs = ({
    emptyFields,
    setEmptyFields,
    setDisplayModal,
    photoPickerFile,
    setPhotoPickerFile,
    whiteListDetail,
    setWhiteListDetail
}) => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState(TABS_WHITE_LIST_MODEL.AUTOMATIC.key);

    return (
        <div className={"w-100 border-radius-8px border-full-shades-300 p-0"}>
            <div className='row px-0'>
                <div className='col-12'>
                    <CustomTabContainer
                        activeTab={selectedTab}
                        setActiveTab={setSelectedTab}
                        className="border-0 px-0"
                    >
                        {Object.values(TABS_WHITE_LIST_MODEL).map((item) => (
                            <CustomTab
                                key={item.key}
                                id={item.key}
                                title={t(item.translation)}
                                icon={item?.icon}
                                selected={selectedTab === item.key}
                                onClick={() => setSelectedTab(item.key)}
                            />
                        ))}
                    </CustomTabContainer>
                </div>

                <div className='col-12 border-bottom-shades-300 px-0'/>

                { selectedTab === TABS_WHITE_LIST_MODEL.AUTOMATIC.key ?
                    <ResidentWhiteListAutomatic
                        photoPickerFile={photoPickerFile}
                        setPhotoPickerFile={setPhotoPickerFile}
                    />
                    :
                    <ResidentWhiteListManual
                        emptyFields={emptyFields}
                        setEmptyFields={setEmptyFields}
                        setDisplayModal={setDisplayModal}
                        whiteListDetail={whiteListDetail}
                        setWhiteListDetail={setWhiteListDetail}
                    />
                }
            </div>
        </div>
    );
}

export default ResidentWhiteListTabs
